<template>
<div class="h-100">
  <v-row class="h-100">
  <v-col class="h-100" v-if="!openDetail">
    <v-card class="h-100">
      <!-- 頁面標題列（共用元件，融入卡片頂部） -->
      <ListPageHeader
        embedded
        title="黃金計畫選手清單"
        subtitle="管理各年度黃金計畫選手會議清單"
        icon="tabler-medal"
        :count="tableData.length"
      >
        <template #actions>
          <VBtn color="white" variant="flat" class="text-primary font-weight-bold" @click="addAthList()">
            <VIcon icon="tabler-plus" class="mr-1" />新增
          </VBtn>
        </template>
      </ListPageHeader>

      <v-card-item>
        <div class="d-flex align-center mb-1">
          <VIcon icon="tabler-filter" size="20" class="text-primary mr-2" />
          <span class="text-subtitle-1 font-weight-medium">篩選條件</span>
        </div>
        <v-row class="pt-2 pb-5">
          <v-col cols="12" md="4">
            <v-select
              label="年度"
              v-model="yearSelect"
              :items="searchMeetingTableSelectData"
              prepend-inner-icon="tabler-calendar"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-item>

      <InteractiveDataTable
        v-model:page="page"
        v-model:items-per-page="pageSize"
        :items-length="tableData.length"
        :items="pagedTableData"
        :headers="tableHeaders"
        :loading="tableLoading"
        :row-clickable="false"
        empty-text="尚無黃金計畫選手清單"
        empty-subtitle="可切換上方年度後再查詢"
        empty-icon="tabler-medal"
        :items-per-page-options="[
          {value: 10, title: '10'},
          {value: 25, title: '25'},
          {value: 50, title: '50'},
          {value: 100, title: '100'},
        ]"
      >
        <template v-slot:item.projectExample="{ item }">
          <v-tooltip v-if="item.projectExample" location="top" text="下載黃金計畫範例">
            <template #activator="{ props: tipProps }">
              <VBtn v-bind="tipProps" icon="tabler-download" @click.prevent="getJwtBeforeRedirect(item.projectExample)" variant="tonal" color="primary" size="small" />
            </template>
          </v-tooltip>
          <span v-else class="text-disabled">—</span>
        </template>

        <template v-slot:item.isPublish="{ item }">
          <v-chip
            :color="item.isPublish ? 'success' : 'grey'"
            variant="tonal"
            size="small"
            class="font-weight-bold"
          >
            <VIcon :icon="item.isPublish ? 'tabler-check' : 'tabler-clock'" size="14" start />
            {{ item.isPublish ? '已公告' : '未公告' }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex align-center">
            <v-tooltip location="top" text="編輯">
              <template #activator="{ props: tipProps }">
                <VBtn v-bind="tipProps" icon="tabler-edit" variant="tonal" color="secondary" size="small" class="idt-action-btn me-2" @click.stop="openEdit(item)" />
              </template>
            </v-tooltip>
            <v-tooltip v-if="!item.isPublish" location="top" text="刪除">
              <template #activator="{ props: tipProps }">
                <VBtn v-bind="tipProps" icon="tabler-trash" variant="tonal" color="error" size="small" class="idt-action-btn" @click.stop="deleteMeeting(item)" />
              </template>
            </v-tooltip>
          </div>
        </template>
      </InteractiveDataTable>
    </v-card>
  </v-col>
  <v-col v-if="openDetail">
    <v-card>
      <v-row class="ma-0">
        <v-col cols="12" md="12" class="d-flex justify-end">
          <v-btn v-if="tbtca21Vo.meetingId&&!tbtca21Vo.isPublish&&tbtca22Vos.length>0" variant="tonal" color="success" class="mr-2" @click="annouce"> 公告</v-btn>
          <v-btn  v-if="!tbtca21Vo.isPublish" variant="tonal" color="primary" class="mr-2" @click="save()">儲存</v-btn>
          <v-btn color="secondary" variant="tonal" class="mr-2" @click="openDetail=false">返回</v-btn>
        </v-col>
      </v-row>  
      <v-form ref="tableContent">
        <v-row class="ma-0">
          <v-col cols="12" class="py-1 px-0">
            <!-- <v-card class="mb-5"> -->
              <v-card-item class="pa-2 pl-4">
                <v-row>
                  <v-col>
                    <span class="mb-1 text-body-2">公文號</span>
                    <v-text-field
                      v-model="tbtca21Vo.docNo"
                      :id="'公文號'"
                      :rules="[rules.required,(v) => v.length <= 10 || '公文號最多10字']"
                      :readonly="tbtca21Vo.isPublish=='Y'"
                    />
                  </v-col>
                  <v-col >
                    <span class="mb-1 text-body-2">年度</span>
                    <v-select
                      v-model="tbtca21Vo.fiscalYear"
                      :rules="[rules.required]"
                      id="年度"
                      :items="memberListYear"
                      :readonly="tbtca21Vo.isPublish=='Y'"
                    />
                  </v-col>
                  <v-col class="">
                    <span class="mb-1 text-body-2">名稱</span>
                    <v-text-field
                      :rules="[rules.required]"
                      v-model="tbtca21Vo.meetingName"
                      id="名稱"
                      type="text"
                      :readonly="tbtca21Vo.isPublish=='Y'"
                    />
                  </v-col>
                  <v-col >
                    <div v-if="tbtca21Vo.projectExample" class="d-flex align-center h-100">
                      <span class="mb-1 text-body-2" style="min-width:90px">黃金計畫範例</span>
                      <div class="d-flex justify-space-between w-100">
                        <VBtn icon="tabler-download" href="" variant="outlined" color="primary"  class="ml-2" @click.prevent="getJwtBeforeRedirect(tbtca21Vo.projectExample)"/>
                        <v-btn class="bg-white mr-4" color="black" variants="text" icon="tabler-x" @click="tbtca21Vo.projectExample=''"
                        :disabled="tbtca21Vo.isPublish=='Y'"></v-btn>
                      </div>
                    </div>
                    <div v-else>
                      <label class="mb-1 text-body-2" style="line-height: 15px;">黃金計畫範例</label>
                      <VFileInput :readonly="tbtca21Vo.isPublish=='Y'" label="" v-model="tbtca21Vo.projectExample" @change="handleOfficalFile('projectExample')" @click:clear="tbtca21Vo.projectExample=''"/>
                    </div>
                  </v-col>
                </v-row>
              </v-card-item>
            <!-- </v-card> -->
            <!-- <v-card> -->
              <v-card-item class="py-1" v-if="tbtca21Vo.isPublish!=='Y'">
                <v-row class="ma-0">
                  <v-col cols="6" class="py-1">
                  </v-col>
                  <!-- <v-col cols="2">
                  </v-col>
                  <v-col cols="3">
                  </v-col> -->
                  <v-col cols="6" class="d-flex justify-end ">
                    <!-- <v-icon icon=""></v-icon> -->
                    <v-btn
                      prepend-icon="tabler-file-download" 
                      @click="sampleFile"
                      color="primary"
                      variant="text"
                      class="mr-2"
                      > 
                      範例excel檔
                    </v-btn>
                    <VFileInput  v-model="viewParams.upExcelList" label="上傳清單" @change="parserExcel" class="mr-4"/>
                    <VBtn icon="tabler-plus" @click="tbtca22VoDlg.new" class="mr-2"  />
                    <VBtn
                      color="error"
                      variant="tonal"
                      icon="tabler-trash"
                      @click="deleteList"
                    />
                  </v-col>
                </v-row>
              </v-card-item>
              <v-data-table
              :loading="memberListLoading"
              :headers="headers"
              :items="tbtca22Vos"
              class="elevation-1"
              v-model="tableSelect.selected"
              :show-select="tbtca21Vo.isPublish!=='Y'" items-per-page="-1"
              no-data-text="尚無資料"
              item-value="athleteId" >
              <!-- fixed-header height="350px"  -->
              <template v-slot:item.athleteLevel="{ item }">
                {{ athletelevelToText(item.athleteLevel) }}
              </template>
              <template v-slot:item.deptNo="{ item }">
                {{ deptToText(item.deptNo) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <VBtn icon="tabler-edit"  variant="outlined" color="secondary" @click="tbtca22VoDlg.edit(item)" class="ml-2"/>
              </template>
              <!-- <template v-slot:bottom> </template> -->
              </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    </v-col>
  </v-row>
  <VDialog v-model="tbtca22VoDlg.isShow" max-width="600px" no-click-animation persistent :retain-focus="false">
    <v-card>
      <v-card-title>
        <span class="headline">新增黃金選手</span>
      </v-card-title>
      <v-card-item>
        <v-form ref="dlgFormRef">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">選手姓名</div>
                <v-text-field
                  v-model="tbtca22VoDlg.vo.athleteName"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">協會</div>
                <v-select
                  v-model="tbtca22VoDlg.vo.deptNo"
                  :items="deptList"
                  item-title="單位名稱"
                  item-value="單位代號"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">異動原因</div>
                <v-text-field
                  v-model="tbtca22VoDlg.vo.reasonForChange"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">生效日期</div>
                <AppDateTimePicker
                  v-model="tbtca22VoDlg.vo.effectiveDate"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">項目名稱</div>
                <v-text-field
                  v-model="tbtca22VoDlg.vo.projectName"
                  :rules="[rules.required]">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">選手級別</div>
                <v-select
                  v-model="tbtca22VoDlg.vo.athleteLevel"
                  :items="athletelevelList"
                  item-title="label"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">申請起日</div>
                 <AppDateTimePicker
                  v-model="tbtca22VoDlg.vo.applyStartDate"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-subtitle-2">申請訖日</div>
                 <AppDateTimePicker
                  v-model="tbtca22VoDlg.vo.applyEndDate"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-item>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="tbtca22VoDlg.isShow = false">取消</v-btn>
        <v-btn color="blue darken-1" text  v-if="tbtca22VoDlg.isNew" @click="tbtca22VoDlg.newOk">新增</v-btn>
        <v-btn color="blue darken-1" text  v-if="tbtca22VoDlg.isEdit" @click="tbtca22VoDlg.editOk">儲存</v-btn>
      </v-card-actions>
    </v-card>
  </VDialog>
</div>
</template>

<script  setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { useRouter } from "vue-router"
import { useDisplay } from 'vuetify'

const router = useRouter()
const route = useRoute()


definePage({
  meta: {
    action: 'manage', //固定為 manage
      subject: 'GOLDPLANATHLETELIST', //系統代碼(系統授權設定中的系統代碼)
  },
});


const dlgFormRef = ref(null);
const rules = ref({
   required: (value: any) => !!value || '此欄位為必填',
});


const tableSelect = reactive({
  selected: []
});

const viewParams = reactive({
  upExcelList: [],
});

// ATHLETELEVEL 選手級別 簡易共用表格
const { data: athletelevelList, execute: fetchAthletelevel } =
  await useApi<any>(
    createUrl("/q/de/select/select/select/deSelect", {
      query: {
        tabId: "ATHLETELEVEL",
      },
    })
  );

const { data: deptList, execute: fetchDeptList } =
  await useApi<any>(
    createUrl("/q/du/org/department/pickDepartment", {
      query: {
        compId: 'nstc',
        orgType:'A',
      },
    })
  );

const athletelevelToText = (level)=> {
  return athletelevelList.value.find(item => item.value === level).label;
}

const deptToText = (deptNo)=> {
  return deptList.value.find(item => item['單位代號'] === deptNo)['單位名稱'];
}

const tbtca21Vo = reactive({
  id: '',             //ID
  meetingId: '',      //ID
  fiscalYear: '',     //年度
  meetingDate: '',    //會議日期
  meetingName: '',    //會議名稱>名稱
  meetingFile:'',     
  docFile:'',         //
  docNo:'',           //公文號
  projectExample:'',  //黃金計畫範例
  isPublish:'',       //已公告

});    
const tbtca21VoOrgin = JSON.parse(JSON.stringify(tbtca21Vo));

const tbtca22Vos = reactive([]);
const fileUrl = useStorage("drFsUrl").value;
onMounted(() => {
  searchTable()
});


const headers = computed(()=>{
  let headersData =
  [
  { title: "選手姓名", key: "athleteName", sortable: false },
  { title: "協會", key: "deptNo" , sortable: false},
  { title: "異動原因", key: "reasonForChange", sortable: false },
  { title: "生效日期", key: "effectiveDate", sortable: false },
  { title: "項目名稱", key: "projectName", sortable: false },
  { title: "選手級別", key: "athleteLevel", sortable: false },
  { title: "申請期間", key: "applyStartDate", sortable: false },
  // { title: "操作", key: "actions", sortable: false },
  ]
  if(tbtca21Vo.isPublish=='Y'){
    return headersData
  }else{
    return [...headersData,{ title: "操作", key: "actions", sortable: false }]
  }
});
const memberListLoading=ref(false)

const tbtca22VoDlg = reactive({
  isShow: false,
  isEdit: false,
  isNew: false,
  orign: {},
  vo: {
      athleteId: '',
      meetingId: '',
      athleteName: '',
      deptNo: '',
      reasonForChange: '',
      effectiveDate: '',
      projectName: '',
      athleteLevel: '',
      applyStartDate: '',
      applyEndDate: '',
  },
  edit: (tca16Vo:any) => {
    tbtca22VoDlg.orign = tca16Vo;
    tbtca22VoDlg.vo = Object.assign({}, tca16Vo);
    tbtca22VoDlg.isEdit= true;
    tbtca22VoDlg.isNew= false;
    tbtca22VoDlg.isShow= true;
  },
  editOk: async() => {
    if(await tbtca22VoDlg.validate()) {
      Object.assign(tbtca22VoDlg.orign, tbtca22VoDlg.vo);
      tbtca22VoDlg.isShow = false;
    } 
  },
  new: () => {
    for (var member in tbtca22VoDlg.vo) delete tbtca22VoDlg.vo[member];
    tbtca22VoDlg.vo.athleteId = 'G'+ currentMillisecond();
    tbtca22VoDlg.vo.meetingId = tbtca21Vo.meetingId;
    tbtca22VoDlg.isEdit= false;
    tbtca22VoDlg.isNew= true;
    tbtca22VoDlg.isShow= true;
  },
  newOk: async() => {
    if(await tbtca22VoDlg.validate()) {
      tbtca22Vos.push(Object.assign({}, tbtca22VoDlg.vo));
      tbtca22VoDlg.isShow = false;
    } 
  },
  validate: async () => {
    const { valid } = await dlgFormRef.value.validate();
    return valid
  }

});

// ---------search table
const tableContent = ref(null);
const isNew = ref(false)
const openDetail=ref(false)
const page = ref(1)
const pageSize = ref(100)
const tableHeaders = [
  { title: "公文號", key: "docNo", sortable: false, icon: "tabler-file-text" },
  { title: "年度", key: "fiscalYear", sortable: false, icon: "tabler-calendar" },
  { title: "名稱", key: "meetingName", sortable: false, icon: "tabler-clipboard-text" },
  { title: "黃金計畫範例", key: "projectExample", sortable: false, icon: "tabler-file-download" },
  { title: "已公告", key: "isPublish", sortable: false, icon: "tabler-speakerphone" },
  { title: "操作", key: "actions", sortable: false, icon: "tabler-settings" },
]
const tableLoading=ref(false)
const tableData=reactive([])

// client 端分頁切片（資料一次抓回，前端分頁）
const pagedTableData = computed(() => {
  if (pageSize.value === -1) return tableData
  const start = (page.value - 1) * pageSize.value

  return tableData.slice(start, start + pageSize.value)
})
const yearSelect=ref(new Date().getFullYear()-1911);
const { data: searchMeetingTableSelectDatas, execute: searchMeetingTableSelect } = await useApi<any>(createUrl('/tca/athletelist/get/select', {
}))
const searchMeetingTableSelectData = computed(()=>searchMeetingTableSelectDatas.value.data?.fiscalYearSelect)


const searchTable = async () => {
  tableLoading.value = true;
  page.value = 1;
  const apiUrl='/tca/athletelist/search/main'
  await $api(apiUrl, {
    method: 'POST',
    body: {
      fiscalYear:yearSelect.value 
    }
  }).then((resp) => {
    if (resp.statusCode == 200) {
      tableData.splice(0, tableData.length, ...resp.data);
    } else  {
      popSwal('error','搜尋失敗,錯誤訊息'+resp.data);
    }
  }).finally(() => {
    tableLoading.value = false;
  })
};

const addAthList = () => {
  openDetail.value = true;
  Object.assign(tbtca21Vo, tbtca21VoOrgin);
  tbtca22Vos.splice(0, tbtca22Vos.length);
};

const deleteMeeting = (meeting)=>{
  console.log(meeting)
  $swal({
    title: `確定刪除${meeting.fiscalYear}年度 ${meeting.meetingName} 資料?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: '我要刪除',
    cancelButtonText: '取消',
  }).then((result) => {
    if (result.isConfirmed) {
      const apiUrl='/tca/athletelist/delete/main'
      $api(apiUrl, {
        method: 'POST',
        params: { 
          meetingId: meeting.meetingId
        }
      }).then((resp) => {
        if (resp.statusCode == 200) {
          popSwal('success','刪除成功');
          searchTable();
        } else  {
          popSwal('error','刪除失敗','錯誤訊息'+resp.data);
        }
      })
    }
  })
}


// --------------------------------- tableSearch ---------------------------------

// ----------------------------------memberList Table---------------------------------
const getCurrentRocYear = () => {
  const currentYear = new Date().getFullYear();
  const currentRocYear = currentYear-1911;
  return currentRocYear;
}

const memberListYear = [getCurrentRocYear(), getCurrentRocYear()+1, getCurrentRocYear()+2]


const openEdit = async(item) => {
  openDetail.value = true;
  console.log(item);
  Object.assign(tbtca21Vo, item);
  await search(item.meetingId)
};

const parserExcel = async () => {
  if (viewParams.upExcelList) {
    memberListLoading.value = true;
    const formData = new FormData();
    formData.append('file',viewParams.upExcelList[0]);
    const apiUrl='/tca/athletelist/uploadList'
    await $api(apiUrl, {
      method: 'POST',
      body: formData
    }).then((resp) => {
      memberListLoading.value = false;
      if (resp.statusCode == 200) {
        tbtca22Vos.length = 0;
        Object.assign(tbtca22Vos, resp.data); 
        tbtca22Vos.forEach(function(tbtca22Vo) {
          tbtca22Vo.meetingId = tbtca21Vo.meetingId;
        });
        popSwal('success','上傳讀取檔案成功');
      } else  {
        popSwal('error','上傳讀取檔案失敗,錯誤訊息'+resp.data);
      }
    })
  }
};

const dialogParams = reactive({
  tbtca22Vo: {},
  isShow: false,
});


const search = async (meetingId) => {
  memberListLoading.value = true;
  tbtca22Vos.length = 0;
  const formData = new FormData();
  formData.append('meetingId', meetingId);
  const apiUrl='/tca/athletelist/search'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
      Object.assign(tbtca22Vos, resp.data); 
    } else  {
      popSwal('error','搜尋失敗,錯誤訊息'+resp.data);
    }
    memberListLoading.value = false;
  })
};

const save = async (noShowPopSwal = null) => {
  const { errors,valid } = await tableContent.value.validate();
  if (valid) {
    console.log(tbtca22Vos, tbtca21Vo);
    const apiUrl = '/tca/athletelist/save';
    return $api(apiUrl, {
      method: 'POST',
      body: {
        tbtca22Vos: tbtca22Vos,
        tbtca21Vo: tbtca21Vo,
      }
    })
      .then((resp) => {
        if (resp.statusCode == 200) {
          if (resp.data) {
            tbtca21Vo.meetingId = resp.data;
          }
          if (noShowPopSwal) {
            console.log('noShowPopSwal');
            return true;
          }
          searchTable();
          popSwal('success', '儲存成功', resp.data?.message || '');
          return true; // 回傳成功結果
        } else {
          if (noShowPopSwal) {
            console.log('noShowPopSwal false');
            return false;
          }
          popSwal(
            'error',
            '儲存失敗',
            `${resp.message ?? ''} 錯誤訊息 ${resp.data ?? ''}`
          );
          return false; // 回傳失敗結果
        }
      })
      .catch((error) => {
        console.error('API 呼叫失敗:', error);
        popSwal('error', '儲存錯誤', error.message || '無法連接伺服器');
        return false; // 回傳失敗結果
      });
  } else {
    const error= errors.map(item => item.id)
    console.log('error 638',errors)
    popSwal('error', '請確認欄位輸入',error);
    return false;
  }
};

const annouce = async()=>{
  const apiUrl='/tca/athletelist/publish'
  const resSave = await save(true);
  console.log(resSave)
  if(resSave){
    console.log('anniunce')
    memberListLoading.value = true;
    await $api(apiUrl, {
      method: 'POST',
      params: {
        meetingId: tbtca21Vo.meetingId,
      }
    }).then((resp) => {
      memberListLoading.value = false;
      if (resp.statusCode == 200) {
        searchTable();
        popSwal('success','公告成功');
        tbtca21Vo.isPublish = 'Y';
      } else  {
        popSwal('error','公告失敗',resp.message??''+resp.data??'');
      }
    }).catch((error) => {
      memberListLoading.value = false;
      console.error('API 呼叫失敗:', error);
      popSwal('error', '公告錯誤', error.message || '無法連接伺服器');
    });
  }
}

const deleteList = async () => {
  const resultList = tbtca22Vos.filter(tbtca22Vo => {
    return !tableSelect.selected.some(select => select === tbtca22Vo.athleteId)
  });
  tableSelect.selected = [];
  tbtca22Vos.length = 0;
  Object.assign(tbtca22Vos, resultList); 
};



const sampleFile= async () => {
  const apiUrl='/tca/athletelist/sampleFile'
  await $api(apiUrl, {
    method: 'GET'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response]));
    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', '黃金計畫選手-上傳清單範例.xlsx');
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};

const popSwal = (icon,title,text=null) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

function currentMillisecond() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份從0開始，所以+1
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const   
 seconds = String(now.getSeconds()).padStart(2, '0');
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}

// 上傳文件
const handleOfficalFile = (val) => {
  if (tbtca21Vo[val]) {
    // let arr =[]
    const formData = new FormData();
    tbtca21Vo[val].forEach((file, index) => {
      formData.append('file', file);
    });
    uploadFile(formData,val)
  }
};

// 上傳文件
const uploadFile =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/upload`, {
      method: 'POST',
      body: files,
    });
    tbtca21Vo[val] = response.fileId
    // console.log('File uploaded successfully', response.data);
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}
const getJwtBeforeRedirect = async (fileId) => {
  const url = await mapFileDownload(fileUrl, fileId)
  window.open(url,'_blank');
};

watch(yearSelect, (val) => {
  searchTable()
});
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>
